// DROPDOWN
const dropdownWraps = document.querySelectorAll('.c-dropdown-wrap');
if(dropdownWraps.length > 0) {
  dropdownWraps.forEach(dropdown => {
    const toggle = dropdown.querySelector('.c-dropdown-toggle');
    
    // CHECK IF TOUCH DEVICE
    if(window.matchMedia('(hover: none)').matches) {
      // OPEN ON CLICK
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        dropdown.classList.toggle('is-open');
      });
      
      // CLOSE ON OUTSIDE CLICK
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('is-open');
        }
      });
    }
  });
}